import { render, staticRenderFns } from "./BulkMetadataFields.vue?vue&type=template&id=9f9dc6b8&scoped=true"
import script from "./BulkMetadataFields.vue?vue&type=script&lang=js"
export * from "./BulkMetadataFields.vue?vue&type=script&lang=js"
import style0 from "./BulkMetadataFields.vue?vue&type=style&index=0&id=9f9dc6b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9dc6b8",
  null
  
)

export default component.exports